const URL_BASE=process.env.REACT_APP_API;
export const URL_PAYMENT=`${URL_BASE}/financial/payments/list`;
